export const ENTER = 13;

export const SPACE = 32;

export const TAB = 9;

export const UP_ARROW = 38;

export const DOWN_ARROW = 40;

export const ESCAPE = 27;
